import { useEffect, useMemo, useState } from "react";

import { useReferentialProjectCostTypes } from "@/entities/referential/referential-project-cost-types";

const getCostTypeDescription = (costTypes, type) => {
  const typeData = costTypes.find((costType) => costType.slug === type);

  if (!typeData?.description) return undefined;

  return `${typeData.name} (${typeData.description})`;
};

export const useAdditionalCostTypeDescription = (defaultType) => {
  const [type, setType] = useState(undefined);
  const { costTypes } = useReferentialProjectCostTypes();

  useEffect(() => {
    if (defaultType && !type) setType(defaultType);
  }, [defaultType, type]);

  const typeDescription = useMemo(
    () => getCostTypeDescription(costTypes, type),
    [type, costTypes]
  );

  const onTypeChange = (value) => {
    setType(value);
  };

  return {
    typeDescription,
    onTypeChange,
  };
};
